import React, { useMemo } from "react";
import Select from "react-select";
import { OPTIONS, STATUS_OPTIONS } from "./config";
import EmployeeFilterDropdown from "components/Common/Dropdowns/EmployeeFilterDropdown";
import FilterBar from "components/Common/FilterBar";

const TARGET_TYPE_OPTIONS = [
  { key: "MONTHLY", value: "Monthly" },
  { key: "QUARTERLY", value: "Quarterly" },
  { key: "YEARLY", value: "Yearly" },
];

const getFinancialYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let i = currentYear - 3; i <= currentYear + 2; i++) {
    years.push({
      key: `${i}-${(i + 1).toString().slice(-2)}`,
      value: `${i}-${(i + 1).toString().slice(-2)}`,
    });
  }

  return years;
};

const Filter = (props) => {
  const { filters, updateFilter } = props;

  const targetTypeOptionsFormatted = useMemo(
    () =>
      TARGET_TYPE_OPTIONS.map((opt) => ({
        label: opt.value,
        value: opt.key,
      })),
    [],
  );

  const financialYearOptions = useMemo(() => getFinancialYearOptions(), []);
  const financialYearOptionsFormatted = useMemo(
    () =>
      financialYearOptions.map((opt) => ({
        label: opt.value,
        value: opt.key,
      })),
    [financialYearOptions],
  );

  const selectedTargetType = targetTypeOptionsFormatted.find(
    (opt) => opt.value === filters.target_type,
  );

  const selectedFinancialYear = financialYearOptionsFormatted.find(
    (opt) => opt.value === filters.financial_year,
  );

  const additionalFilterBadges = [
    {
      id: "target-type",
      label: "Target Type",
      value: selectedTargetType?.label,
      onRemove: () => updateFilter("target_type", ""),
    },
    {
      id: "financial-year",
      label: "Financial Year",
      value: selectedFinancialYear?.label,
      onRemove: () => updateFilter("financial_year", ""),
    },
    {
      id: "employee-code",
      label: "Employee Code",
      value: filters.employee_code_id,
      onRemove: () => updateFilter("employee_code_id", ""),
    },
  ];

  return (
    <FilterBar
      options={OPTIONS}
      statusOptions={STATUS_OPTIONS}
      additionalFilterBadges={additionalFilterBadges}
      additionalFilterControls={
        <div className="employee-target-selects">
          <div className="employee-target-select">
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Target Type"
              options={targetTypeOptionsFormatted}
              value={selectedTargetType || null}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              onChange={(selected) =>
                updateFilter("target_type", selected?.value || "")
              }
              isClearable
            />
          </div>

          <div className="employee-target-select">
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Financial Year"
              options={financialYearOptionsFormatted}
              value={selectedFinancialYear || null}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              onChange={(selected) =>
                updateFilter("financial_year", selected?.value || "")
              }
              isClearable
            />
          </div>

          <div className="employee-target-select employee-target-employee-select">
            <EmployeeFilterDropdown
              setFilterValue={updateFilter}
              selectedValue={filters.employee_code_id}
              className="w-100"
            />
          </div>
        </div>
      }
      {...props}
    />
  );
};

export default Filter;
